import script from "./multi-select-generic.vue?vue&type=script&setup=true&lang=ts"
export * from "./multi-select-generic.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__